import React from 'react';
import { CalendarIcon, ArrowUpRightIcon } from 'lucide-react';
export const CTABanner = () => {
  return <section className="py-14 md:py-20 bg-white text-[#1B2A4A]" data-id="element-109">
      <div className="container mx-auto px-6 text-center" data-id="element-110">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-111">
          Ready to maximize your sponsorship revenue?
        </h2>
        <p className="text-xl text-[#1B2A4A]/70 max-w-3xl mx-auto mb-8 md:mb-10 leading-relaxed" data-id="element-112">
          Our clients typically see a 30-45% increase in sponsorship revenue
          within their first event cycle.
        </p>
        <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-113">
          <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="inline-flex items-center justify-center gap-3 bg-[#B87333] hover:bg-[#B87333]/90 text-[#1B2A4A] px-6 py-3.5 md:px-8 md:py-4 rounded-md font-medium text-lg transition-all shadow-md w-full sm:w-auto" data-id="element-114">
            <CalendarIcon size={20} data-id="element-115" />
            Schedule a Free Consultation
          </a>
          <a href="#resources" className="inline-flex items-center justify-center gap-3 bg-transparent border border-[#1B2A4A]/20 text-[#1B2A4A] px-6 py-3.5 md:px-8 md:py-4 rounded-md font-medium text-lg hover:bg-[#1B2A4A]/5 transition-all shadow-sm w-full sm:w-auto" data-id="element-116">
            Explore Resources <ArrowUpRightIcon size={20} data-id="element-117" />
          </a>
        </div>
      </div>
    </section>;
};